// @ts-nocheck
import angular from 'angular';

export class Constants {
  PhotoStatuses = {
    PendingReview: 'pending_review',
    Approved: 'approved',
    Rejected: 'rejected',
    Deleted: 'deleted',
  };

  visitTypes = [
    { type: 'all', description: 'All Visit Types' },
    { type: 'true', description: 'SLV' },
    { type: 'false', description: 'Async' },
  ];

  partnerships = [
    { type: 'all', description: 'All Partners' },
    { type: 'ih', description: 'Lemonaid' },
    { type: 'qd', description: 'Quest Diagnostics' },
  ];

  UnitConversionRate = {
    INCH_TO_CM_CONVERSION_RATE: 2.54,
    CM_TO_INCH_CONVERSION_RATE: 0.393701,
    STONE_TO_KILOGRAM_CONVERSION_RATE: 6.35029,
    POUNDS_TO_KILOGRAM_CONVERSION_RATE: 0.453592,
    KILOGRAM_TO_POUNDS_CONVERSION_RATE: 2.20462,
  };

  VisitStatuses = {
    Open: 0,
    PendingReview: 1,
    UserCancelled: 2,
    Approved: 3,
    Closed: 4,
    Rejected: 5,
  };
  VisitTasks = {
    Questionnaire: 1,
    ExamVideo: 2,
    MultiPhoto: 3,
    SmartLiveVideo: 4,
    Payment: 5,
    Delivery: 6,
    AssignAffiliate: 7,
    AssignEMR: 8,
    DispatchTestKit: 9,
    TestResults: 10,
    PrescribeMedication: 11,
    Finalise: 12,
    Callback: 13,
    Account: 14,
    OrderLabs: 15,
    ReviewLabResults: 16,
  };

  AdminStatuses = {
    All: { NumericValue: 'all', StringValue: 'All' },
    PaymentReceived: { NumericValue: 0.1, StringValue: 'Payment Received' },
    Complete: { NumericValue: 10, StringValue: 'Complete' },
    AdminCancelled: { NumericValue: 9.2, StringValue: 'Admin Cancelled' },
    LabOrderSent: { NumericValue: 7.0, StringValue: 'Lab Order Sent' },
    LabResultsReceived: { NumericValue: 7.7, StringValue: 'Lab Results Received' },
    New: { NumericValue: 0, StringValue: 'New' },
    QuestionnaireSubmitted: { NumericValue: 4.1, StringValue: 'Questionnaire Submitted' },
    DeliveryAddressSubmitted: { NumericValue: 4.2, StringValue: 'Delivery Address Submitted' },
    MultiPhotoUploaded: { NumericValue: 4.4, StringValue: 'Multi Photo Uploaded' },
    MultiPhotoReUploaded: { NumericValue: 4.5, StringValue: 'Multi Photo Re-uploaded' },
    IdPhotoUploaded: { NumericValue: 4.6, StringValue: 'Id Photo Uploaded' },
    IdPhotoReUploaded: { NumericValue: 4.7, StringValue: 'Id Photo Re-uploaded' },
    ExamPhotoUploaded: { NumericValue: 4.8, StringValue: 'Exam Photo Uploaded' },
    ExamPhotoReUploaded: { NumericValue: 4.9, StringValue: 'Exam Photo Re-uploaded' },
    MedicinePrescribed: { NumericValue: 5.1, StringValue: 'Medicine Prescribed' },
    MultiPhotoApproved: { NumericValue: 5.4, StringValue: 'Exam Photo Approved' },
    MultiPhotoRejected: { NumericValue: 5.5, StringValue: 'Exam Photo Rejected' },
    IdPhotoApproved: { NumericValue: 5.6, StringValue: 'Id Photo Approved' },
    IdPhotoRejected: { NumericValue: 5.7, StringValue: 'Id Photo Rejected' },
    ExamPhotoApproved: { NumericValue: 5.8, StringValue: 'Exam Photo Approved' },
    ExamPhotoRejected: { NumericValue: 5.9, StringValue: 'Exam Photo Rejected' },
    RemoteRxCreated: { NumericValue: 7.1, StringValue: 'Remote Rx Created' },
    RemoteRxSent: { NumericValue: 7.2, StringValue: 'Remote Rx Sent' },
    AssessmentOpen: { NumericValue: 8.1, StringValue: 'Assessment Open' },
    AssessmentComplete: { NumericValue: 8.2, StringValue: 'Assessment Complete' },
    Abandoned: { NumericValue: 9.8, StringValue: 'Expired' },
    UserCancelled: { NumericValue: 9.9, StringValue: 'User Cancelled' },
    PatientHistoryCheck: { NumericValue: 2.1, StringValue: 'Running patient history check' },
    AwaitingIdApproval: { NumericValue: 2.5, StringValue: 'Awaiting ID approval' },
    AwaitingIdUpload: { NumericValue: 2.4, StringValue: 'Additional ID Photos Requested' },
    //TODO: Harold - additional photos
    AwaitingAdditionalIdApproval: { NumericValue: 2.51, StringValue: 'Awaiting Additional ID Approval' },
    AdditionalIdPhotosUploaded: { NumericValue: 4.61, StringValue: 'Additional ID Photos Uploaded' },
    AdditionalIdPhotosReUploaded: { NumericValue: 4.71, StringValue: 'Additional ID Photos Re-uploaded' },
    AdditionalPhotosApproved: { NumericValue: 5.61, StringValue: 'Additional ID Photos Approved' },
    AdditionalIdRejected: { NumericValue: 5.71, StringValue: 'Additional ID Photo Rejected' },
    AwaitingAdditionalIdUpload: { NumericValue: 2.52, StringValue: 'Awaiting Additional ID Photos Upload' },
  };

  PhotoTypes = {
    Selfie: { id: 12, name: 'ID' },
    Id: { id: 13, name: 'Selfie' },
    AdditionalSelfie: { id: 22, name: 'Additional ID' },
    AdditionalId: { id: 23, name: 'Additional Selfie' },
  };

  DosespotDispenseUnits = [
    { id: 1, name: 'Bag' },
    { id: 2, name: 'Bottle' },
    { id: 3, name: 'Box' },
    { id: 4, name: 'Capsule' },
    { id: 5, name: 'Cartridge' },
    { id: 6, name: 'Container' },
    { id: 7, name: 'Metric Drop' },
    { id: 8, name: 'Gram' },
    { id: 9, name: 'Inhaler' },
    { id: 11, name: 'Kit' },
    { id: 12, name: 'Liter' },
    { id: 13, name: 'Lozenge' },
    { id: 14, name: 'Milligram' },
    { id: 15, name: 'Milliliter' },
    { id: 18, name: 'Fluid Ounce' },
    { id: 19, name: 'Unspecified' },
    { id: 20, name: 'Package' },
    { id: 21, name: 'Packet' },
    { id: 22, name: 'Pint' },
    { id: 23, name: 'Suppository' },
    { id: 24, name: 'Syringe' },
    { id: 25, name: 'Tablespoon' },
    { id: 26, name: 'Tablet' },
    { id: 27, name: 'Teaspoon' },
    { id: 28, name: 'Patch' },
    { id: 29, name: 'Tube' },
    { id: 30, name: 'Gram' },
    { id: 31, name: 'Vial' },
    { id: 32, name: 'Each' },
    { id: 33, name: 'Gum' },
    { id: 34, name: 'Ampule' },
    { id: 35, name: 'Applicator' },
    { id: 36, name: 'Applicatorful' },
    { id: 37, name: 'Bar' },
    { id: 38, name: 'Bead' },
    { id: 39, name: 'Blister' },
    { id: 40, name: 'Block' },
    { id: 41, name: 'Bolus' },
    { id: 42, name: 'Can' },
    { id: 43, name: 'Canister' },
    { id: 44, name: 'Capler' },
    { id: 45, name: 'Carton' },
    { id: 46, name: 'Case' },
    { id: 47, name: 'Cassette' },
    { id: 48, name: 'Cylinder' },
    { id: 49, name: 'Disk' },
    { id: 50, name: 'Dose Pack' },
    { id: 51, name: 'Dual Packs' },
    { id: 52, name: 'Film' },
    { id: 53, name: 'Gallon' },
    { id: 54, name: 'Implant' },
    { id: 55, name: 'Inhalation' },
    { id: 56, name: 'Inhaler Refill' },
    { id: 57, name: 'Insert' },
    { id: 58, name: 'Intravenous Bag' },
    { id: 59, name: 'Milimeter' },
    { id: 60, name: 'Nebule' },
    { id: 61, name: 'Needle Free Injection' },
    { id: 62, name: 'Oscular System' },
    { id: 63, name: 'Ounce' },
    { id: 64, name: 'Pad' },
    { id: 65, name: 'Paper' },
    { id: 66, name: 'Pouch' },
    { id: 67, name: 'Pound' },
    { id: 68, name: 'Puff' },
    { id: 69, name: 'Quart' },
    { id: 70, name: 'Ring' },
    { id: 71, name: 'Sachet' },
    { id: 72, name: 'Scoopful' },
    { id: 73, name: 'Sponge' },
    { id: 74, name: 'Spray' },
    { id: 75, name: 'Stick' },
    { id: 76, name: 'Strip' },
    { id: 77, name: 'Swab' },
    { id: 78, name: 'Tabminder' },
    { id: 79, name: 'Tampon' },
    { id: 80, name: 'Tray' },
    { id: 81, name: 'Troche' },
    { id: 82, name: 'Wafer' },
    { id: 83, name: 'Pen Needle' },
    { id: 84, name: 'Pre-filled Pen Syringe' },
    { id: 85, name: 'French' },
    { id: 86, name: 'Kilogram' },
    { id: 87, name: 'Milliequivalent' },
    { id: 88, name: 'Pump' },
  ];
}
